import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { ArrowRight } from '@phosphor-icons/react';

/**
 * AAnnouncementBar Component
 * Displays an announcement banner with a link
 *
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to show the announcement
 * @param {string} props.title - The announcement text
 * @param {string} props.link - The URL to navigate to when clicked
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element|null} The announcement component or null if show is false
 */
export const AAnnouncementBar = ({ show, title, link, className = '' }) => {
  if (!show || !title || !link) {
    return null;
  }

  return (
    <Link
      to={link}
      className={classNames(
        'flex w-max items-center gap-2 rounded-full border border-black/20 bg-white px-4 py-1.5 text-sm font-medium tracking-[0.16px] text-black transition-smooth hover:bg-black/5',
        className
      )}
    >
      {title} <ArrowRight size={14} weight="bold" />
    </Link>
  );
};

AAnnouncementBar.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  className: PropTypes.string,
};
